import React from 'react';
import { observer } from '../../shared/observer';
import { SmsLogin } from './SmsLogin';
import { PhoneCallLogin } from './PhoneCallLogin';
import { EmailLogin } from './EmailLogin';

class LoginDialogView extends React.Component {
  close = () => this.props.auth.setLoginDialogOpen(false);

  onAuthed = () => this.close();

  render() {
    const auth = this.props.auth;
    if (!auth.loginDialogOpen) return null;
    let inner = null;
    switch (auth.authType) {
      case 'sms':
        inner = <SmsLogin onAuthed={this.onAuthed} />;
        break;
      case 'email':
        inner = <EmailLogin onAuthed={this.onAuthed} />;
        break;
      case 'client_call':
      default:
        inner = <PhoneCallLogin onAuthed={this.onAuthed} />;
    }
    return (
      <div className="dialog">
        <div className="dialog__bg" onClick={this.close} />
        <div className="dialog__content">
          <div className="dialog__close" onClick={this.close} />
          {inner}
        </div>
      </div>
    );
  }
}

export const LoginDialog = observer(LoginDialogView, ['authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Auth/LoginDialog.jsx